import Http from './../../services/HTTP';
const querystring = require('querystring');

const GET_LAB_ORDER_CANCEL_REASONS = "GET_LAB_ORDER_CANCEL_REASONS";
const GET_PHARMACY_ORDER_CANCEL_REASONS = "GET_PHARMACY_ORDER_CANCEL_REASONS";
const REJECT_LAB_ORDER = "REJECT_LAB_ORDER";
const ACCEPT_LAB_ORDER = "ACCEPT_LAB_ORDER";
const ADD_SAMPLING_DATA = "ADD_SAMPLING_DATA";
const SAMPLING_DONE = "SAMPLING_DONE";
const SEND_LAB_ORDER_RESULT = "SEND_LAB_ORDER_RESULT";
const MAKE_LAB_ORDER_DONE = "MAKE_LAB_ORDER_DONE";
const GET_VENDOR_ORDERS = 'GET_VENDOR_ORDERS';
const UPDATE_PHARMACY_ORDER_LAST_ASSIGN_TIME = 'UPDATE_PHARMACY_ORDER_LAST_ASSIGN_TIME';
const ACCEPT_PHARMACY_ORDER = "ACCEPT_PHARMACY_ORDER";
const REJECT_PHARMACY_ORDER = "REJECT_PHARMACY_ORDER";


// allOrders to admin panel starts here
function allOrdersWaiting() {
  return {
    type : GET_VENDOR_ORDERS,
    all_orders_waiting : true,
    all_orders_response : {},
    all_orders_error : {}
  }
}

function allOrdersSuccess(response) {
  return {
    type: GET_VENDOR_ORDERS,
    all_orders_waiting : false,
    all_orders_response : response,
    all_orders_error : {}
  }
}
function ordersEmpty() {
  return {
    type: GET_VENDOR_ORDERS,
    all_orders_waiting : false,
    all_orders_response : {},
    all_orders_error : {}
  }
}

function allOrdersError(error) {
  return {
    type : GET_VENDOR_ORDERS,
    all_orders_waiting : false,
    all_orders_response : {},
    all_orders_error : error
  }
}

function getAllOrders(data) {
  let queryString = querystring.stringify(data);
  let vendor_type = JSON.parse(localStorage.getItem('user'))['vendor_type'];
  vendor_type = vendor_type ?? 'LAB';
  let source = vendor_type === 'DRUG' ? 'pharmacy' : 'lab-test';
  return (dispatch) => {
    dispatch(allOrdersWaiting());
    const get = Http.GET(source+'/v1/orders/all'+'?'+queryString,{});
    get.then((response) => {
      if (response !== undefined)
        dispatch(allOrdersSuccess(response));
    }).catch((error) => {
      dispatch(allOrdersError(error));
    });
  }
}

function getLabOrderCancelReasonsWaiting() {
    return {
      type: GET_LAB_ORDER_CANCEL_REASONS,
      lab_order_cancel_reasons_waiting: true,
      lab_order_cancel_reasons_response: {},
      lab_order_cancel_reasons_error: {},
    };
  }
  
  function getLabOrderCancelReasonsSuccess(response) {
    return {
      type: GET_LAB_ORDER_CANCEL_REASONS,
      lab_order_cancel_reasons_waiting: false,
      lab_order_cancel_reasons_response: response,
      lab_order_cancel_reasons_error: {},
    };
  }
  
  function getLabOrderCancelReasonsError(error) {
    return {
      type: GET_LAB_ORDER_CANCEL_REASONS,
      lab_order_cancel_reasons_waiting: false,
      lab_order_cancel_reasons_response: {},
      lab_order_cancel_reasons_error: error,
    };
  }
  
  function getLabOrderCancelReasons() {
    return (dispatch) => {
      let vendor_type = JSON.parse(localStorage.getItem('user'))['vendor_type'];
      vendor_type = vendor_type ?? 'LAB';
      dispatch(getLabOrderCancelReasonsWaiting());
      const get = Http.GET("lab-test/v1/reject-reasons?type="+vendor_type, {});
      get
        .then((response) => {
          if (response !== undefined) dispatch(getLabOrderCancelReasonsSuccess(response));
        })
        .catch((error) => {
          dispatch(getLabOrderCancelReasonsError(error));
        });
    };
  }



function getPharmacyOrderCancelReasonsWaiting() {
  return {
    type: GET_PHARMACY_ORDER_CANCEL_REASONS,
    pharmacy_order_cancel_reasons_waiting: true,
    pharmacy_order_cancel_reasons_response: {},
    pharmacy_order_cancel_reasons_error: {},
  };
}

function getPharmacyOrderCancelReasonsSuccess(response) {
  return {
    type: GET_PHARMACY_ORDER_CANCEL_REASONS,
    pharmacy_order_cancel_reasons_waiting: false,
    pharmacy_order_cancel_reasons_response: response,
    pharmacy_order_cancel_reasons_error: {},
  };
}

function getPharmacyOrderCancelReasonsError(error) {
  return {
    type: GET_PHARMACY_ORDER_CANCEL_REASONS,
    pharmacy_order_cancel_reasons_waiting: false,
    pharmacy_order_cancel_reasons_response: {},
    pharmacy_order_cancel_reasons_error: error,
  };
}

function getPharmacyOrderCancelReasons() {
  return (dispatch) => {
    dispatch(getPharmacyOrderCancelReasonsWaiting());
    const get = Http.GET("pharmacy/v1/reject-reasons?type=DRUG", {});
    get
        .then((response) => {
          if (response !== undefined) dispatch(getPharmacyOrderCancelReasonsSuccess(response));
        })
        .catch((error) => {
          dispatch(getPharmacyOrderCancelReasonsError(error));
        });
  };
}



  function rejectLabOrderWaiting() {
    return {
      type: REJECT_LAB_ORDER,
      reject_lab_order_waiting: true,
      reject_lab_order_response: {},
      reject_lab_order_error: {},
    };
  }
  
  function rejectLabOrderSuccess(response) {
    return {
      type: REJECT_LAB_ORDER,
      reject_lab_order_waiting: false,
      reject_lab_order_response: response,
      reject_lab_order_error: {},
    };
  }
  
  function rejectLabOrderError(error) {
    return {
      type: REJECT_LAB_ORDER,
      reject_lab_order_waiting: false,
      reject_lab_order_response: {},
      reject_lab_order_error: error,
    };
  }

  function rejectLabOrderEmpty() {
    return {
      type: REJECT_LAB_ORDER,
      reject_lab_order_waiting: false,
      reject_lab_order_response: {},
      reject_lab_order_error: {},
    };
  }
  
  function rejectLabOrder(data) {
    return (dispatch) => {
      dispatch(rejectLabOrderWaiting());
      const get = Http.POST("lab-test/v1/orders/reject/"+data.id, data);
      get
        .then((response) => {
          if (response !== undefined) dispatch(rejectLabOrderSuccess(response));
        })
        .catch((error) => {
          dispatch(rejectLabOrderSuccess(error));
        });
    };
  }

  function acceptLabOrderWaiting() {
    return {
      type: ACCEPT_LAB_ORDER,
      accept_lab_order_waiting: true,
      accept_lab_order_response: {},
      accept_lab_order_error: {},
    };
  }
  
  function acceptLabOrderSuccess(response) {
    return {
      type: ACCEPT_LAB_ORDER,
      accept_lab_order_waiting: false,
      accept_lab_order_response: response,
      accept_lab_order_error: {},
    };
  }
  
  function acceptLabOrderError(error) {
    return {
      type: ACCEPT_LAB_ORDER,
      accept_lab_order_waiting: false,
      accept_lab_order_response: {},
      accept_lab_order_error: error,
    };
  }

  function acceptLabOrderEmpty() {
    return {
      type: ACCEPT_LAB_ORDER,
      accept_lab_order_waiting: false,
      accept_lab_order_response: {},
      accept_lab_order_error: {},
    };
  }
  
  function acceptLabOrder(data) {
    return (dispatch) => {
      dispatch(acceptLabOrderWaiting());
      const get = Http.POST("lab-test/v1/orders/accept/"+data.id, data);
      get
        .then((response) => {
          if (response !== undefined) dispatch(acceptLabOrderSuccess(response));
        })
        .catch((error) => {
          dispatch(acceptLabOrderError(error));
        });
    };
  }


  function addSamplingDataWaiting() {
    return {
      type: ADD_SAMPLING_DATA,
      add_sampling_data_waiting: true,
      add_sampling_data_response: {},
      add_sampling_data_error: {},
    };
  }

  function addSamplingDataSuccess(response) {
    return {
      type: ADD_SAMPLING_DATA,
      add_sampling_data_waiting: false,
      add_sampling_data_response: response,
      add_sampling_data_error: {},
    };
  }
  
  function addSamplingDataError(error) {
    return {
      type: ADD_SAMPLING_DATA,
      add_sampling_data_waiting: false,
      add_sampling_data_response: {},
      add_sampling_data_error: error,
    };
  }

  function addSamplingDataEmpty() {
    return {
      type: ADD_SAMPLING_DATA,
      add_sampling_data_waiting: false,
      add_sampling_data_response: {},
      add_sampling_data_error: {},
    };
  }
  
  function addSamplingData(data) {
    return (dispatch) => {
      dispatch(addSamplingDataWaiting());
      const post = Http.POST("lab-test/v1/orders/sampling-data/"+data.id, data);
      post
        .then((response) => {
          if (response !== undefined) dispatch(addSamplingDataSuccess(response));
        })
        .catch((error) => {
          dispatch(addSamplingDataError(error));
        });
    };
  }


  function samplingDoneWaiting() {
    return {
      type: SAMPLING_DONE,
      sampling_done_waiting: true,
      sampling_done_response: {},
      sampling_done_error: {},
    };
  }

  function samplingDoneSuccess(response) {
    return {
      type: SAMPLING_DONE,
      sampling_done_waiting: false,
      sampling_done_response: response,
      sampling_done_error: {},
    };
  }
  
  function samplingDoneError(error) {
    return {
      type: SAMPLING_DONE,
      sampling_done_waiting: false,
      sampling_done_response: {},
      sampling_done_error: error,
    };
  }

  function samplingDoneEmpty() {
    return {
      type: SAMPLING_DONE,
      sampling_done_waiting: false,
      sampling_done_response: {},
      sampling_done_error: {},
    };
  }
  
  function samplingDone(id) {
    return (dispatch) => {
      dispatch(samplingDoneWaiting());
      const post = Http.POST("lab-test/v1/orders/sampling-done/"+id);
      post
        .then((response) => {
          if (response !== undefined) dispatch(samplingDoneSuccess(response));
        })
        .catch((error) => {
          dispatch(samplingDoneError(error));
        });
    };
  }
  

  function sendLabOrderResultWaiting() {
    return {
      type: SEND_LAB_ORDER_RESULT,
      send_lab_order_result_waiting: true,
      send_lab_order_result_response: {},
      send_lab_order_result_error: {},
    };
  }

  function sendLabOrderResultSuccess(response) {
    return {
      type: SEND_LAB_ORDER_RESULT,
      send_lab_order_result_waiting: false,
      send_lab_order_result_response: response,
      send_lab_order_result_error: {},
    };
  }
  
  function sendLabOrderResultError(error) {
    return {
      type: SEND_LAB_ORDER_RESULT,
      send_lab_order_result_waiting: false,
      send_lab_order_result_response: {},
      send_lab_order_result_error: error,
    };
  }

  function sendLabOrderResultEmpty() {
    return {
      type: SEND_LAB_ORDER_RESULT,
      send_lab_order_result_waiting: false,
      send_lab_order_result_response: {},
      send_lab_order_result_error: {},
    };
  }
  
  function sendLabOrderResult(id,data) {
    return (dispatch) => {
      dispatch(sendLabOrderResultWaiting());
      const post = Http.POST("lab-test/v1/orders/result/"+id,data);
      post
        .then((response) => {
          if (response !== undefined) dispatch(sendLabOrderResultSuccess(response));
        })
        .catch((error) => {
          dispatch(sendLabOrderResultError(error));
        });
    };
  }



  function makeLabOrderDoneWaiting() {
    return {
      type: MAKE_LAB_ORDER_DONE,
      make_lab_order_done_waiting: true,
      make_lab_order_done_response: {},
      make_lab_order_done_error: {},
    };
  }

  function makeLabOrderDoneSuccess(response) {
    return {
      type: MAKE_LAB_ORDER_DONE,
      make_lab_order_done_waiting: false,
      make_lab_order_done_response: response,
      make_lab_order_done_error: {},
    };
  }
  
  function makeLabOrderDoneError(error) {
    return {
      type: MAKE_LAB_ORDER_DONE,
      make_lab_order_done_waiting: false,
      make_lab_order_done_response: {},
      make_lab_order_done_error: error,
    };
  }

  function makeLabOrderDoneEmpty() {
    return {
      type: MAKE_LAB_ORDER_DONE,
      make_lab_order_done_waiting: false,
      make_lab_order_done_response: {},
      make_lab_order_done_error: {},
    };
  }
  
  function makeLabOrderDone(id) {
    return (dispatch) => {
      dispatch(makeLabOrderDoneWaiting());
      const post = Http.POST("lab-test/v1/orders/done/"+id);
      post
        .then((response) => {
          if (response !== undefined) dispatch(makeLabOrderDoneSuccess(response));
        })
        .catch((error) => {
          dispatch(makeLabOrderDoneError(error));
        });
    };
  }



function updatePharmacyOrderLastAssignTimeWaiting() {
  return {
    type : UPDATE_PHARMACY_ORDER_LAST_ASSIGN_TIME,
    update_last_assign_time_waiting : true,
    update_last_assign_time_response : {},
    update_last_assign_time_error : {}
  }
}

function updatePharmacyOrderLastAssignTimeSuccess(response) {
  return {
    type: UPDATE_PHARMACY_ORDER_LAST_ASSIGN_TIME,
    update_last_assign_time_waiting : false,
    update_last_assign_time_response : response,
    update_last_assign_time_error : {}
  }
}
function updatePharmacyOrderLastAssignTimeEmpty() {
  return {
    type: UPDATE_PHARMACY_ORDER_LAST_ASSIGN_TIME,
    update_last_assign_time_waiting : false,
    update_last_assign_time_response : {},
    update_last_assign_time_error : {}
  }
}

function updatePharmacyOrderLastAssignTimeError(error) {
  return {
    type : UPDATE_PHARMACY_ORDER_LAST_ASSIGN_TIME,
    update_last_assign_time_waiting : false,
    update_last_assign_time_response : {},
    update_last_assign_time_error : error
  }
}

function updatePharmacyOrderLastAssignTime(id) {
  return (dispatch) => {
    dispatch(updatePharmacyOrderLastAssignTimeWaiting());
    const get = Http.POST('pharmacy/v1/update-last-assign-time/'+id,{});
    get.then((response) => {
      if (response !== undefined)
        dispatch(updatePharmacyOrderLastAssignTimeSuccess(response));
    }).catch((error) => {
      dispatch(updatePharmacyOrderLastAssignTimeError(error));
    });
  }
}




function acceptPharmacyOrderWaiting() {
  return {
    type : ACCEPT_PHARMACY_ORDER,
    accept_pharmacy_order_waiting : true,
    accept_pharmacy_order_response : {},
    accept_pharmacy_order_error : {}
  }
}

function acceptPharmacyOrderSuccess(response) {
  return {
    type: ACCEPT_PHARMACY_ORDER,
    accept_pharmacy_order_waiting : false,
    accept_pharmacy_order_response : response,
    accept_pharmacy_order_error : {}
  }
}
function acceptPharmacyOrderEmpty() {
  return {
    type: ACCEPT_PHARMACY_ORDER,
    accept_pharmacy_order_waiting : false,
    accept_pharmacy_order_response : {},
    accept_pharmacy_order_error : {}
  }
}

function acceptPharmacyOrderError(error) {
  return {
    type : ACCEPT_PHARMACY_ORDER,
    accept_pharmacy_order_waiting : false,
    accept_pharmacy_order_response : {},
    accept_pharmacy_order_error : error
  }
}

function acceptPharmacyOrder(data) {
  return (dispatch) => {
    dispatch(acceptPharmacyOrderWaiting());
    const post = Http.POST('pharmacy/v1/orders/accept/'+data.id,data);
    post.then((response) => {
      if (response !== undefined)
        dispatch(acceptPharmacyOrderSuccess(response));
    }).catch((error) => {
      dispatch(acceptPharmacyOrderError(error));
    });
  }
}


function rejectPharmacyOrderWaiting() {
  return {
    type : REJECT_PHARMACY_ORDER,
    reject_pharmacy_order_waiting : true,
    reject_pharmacy_order_response : {},
    reject_pharmacy_order_error : {}
  }
}

function rejectPharmacyOrderSuccess(response) {
  return {
    type: REJECT_PHARMACY_ORDER,
    reject_pharmacy_order_waiting : false,
    reject_pharmacy_order_response : response,
    reject_pharmacy_order_error : {}
  }
}
function rejectPharmacyOrderEmpty() {
  return {
    type: REJECT_PHARMACY_ORDER,
    reject_pharmacy_order_waiting : false,
    reject_pharmacy_order_response : {},
    reject_pharmacy_order_error : {}
  }
}

function rejectPharmacyOrderError(error) {
  return {
    type : REJECT_PHARMACY_ORDER,
    reject_pharmacy_order_waiting : false,
    reject_pharmacy_order_response : {},
    reject_pharmacy_order_error : error
  }
}

function rejectPharmacyOrder(data) {
  return (dispatch) => {
    dispatch(rejectPharmacyOrderWaiting());
    const post = Http.POST('pharmacy/v1/orders/reject/'+ data.id,data);
    post.then((response) => {
      if (response !== undefined)
        dispatch(rejectPharmacyOrderSuccess(response));
    }).catch((error) => {
      dispatch(rejectPharmacyOrderError(error));
    });
  }
}




export {
      GET_LAB_ORDER_CANCEL_REASONS,
      getLabOrderCancelReasons,
      REJECT_LAB_ORDER,
      rejectLabOrder,
      rejectLabOrderEmpty,
      ACCEPT_LAB_ORDER,
      acceptLabOrder,
      acceptLabOrderEmpty,
      ADD_SAMPLING_DATA,
      addSamplingData,
      addSamplingDataEmpty,
      SAMPLING_DONE,
      samplingDone,
      samplingDoneEmpty,
      SEND_LAB_ORDER_RESULT,
      sendLabOrderResult,
      sendLabOrderResultEmpty,
      MAKE_LAB_ORDER_DONE,
      makeLabOrderDone,
      makeLabOrderDoneEmpty,
      GET_VENDOR_ORDERS,
      getAllOrders,
      GET_PHARMACY_ORDER_CANCEL_REASONS,
      getPharmacyOrderCancelReasons,
      UPDATE_PHARMACY_ORDER_LAST_ASSIGN_TIME,
      updatePharmacyOrderLastAssignTime,
      REJECT_PHARMACY_ORDER,
      rejectPharmacyOrder,
      rejectPharmacyOrderEmpty,
      ACCEPT_PHARMACY_ORDER,
      acceptPharmacyOrder,
      acceptPharmacyOrderEmpty,
  }